import React, { useState } from 'react';
import './BoardDirectors.css';

const BoardDirectors = () => {
  const [expanded, setExpanded] = useState({});

  const toggleReadMore = (id) => {
    setExpanded(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const directors = [
    {
      id: 'moses',
      name: 'Hon Moses O.T. Owharo',
      position: 'Chairman of the Board',
      image: '/images/Hon-Moses.jpeg',
      bio: `ABVIG is proud to have as its Chairman of the Board Mr. Moses Owharo, a distinguished business and social entrepreneur with a wealth of experience in the fields of Microfinance, Healthcare, and General Business. With certificates from both the prestigious Harvard Business School and George Washington University in the United States, Mr. Owharo brings a wealth of knowledge and expertise to the organization. In addition, Mr. Owharo is the President and CEO of ASPI, a testament to his exceptional leadership abilities.

      Mr. Owharo's accomplishments extend beyond the business world. He has also made significant contributions in the political arena, having been elected as the Executive President of the All Nigerian Community in Ghana by the Electoral Commission of Ghana. The ANC-GH is the umbrella organization for over four million Nigerians in Ghana, including corporate bodies. Mr. Owharo's reputation as a leader has enabled him to successfully lobby prominent political figures in Nigeria and Ghana, including former Presidents Goodluck Jonathan, Atta Mills, John Mahama, J.J. Rawlings, and J.A. Kufuor, as well as various ministers of state, chief directors of ministries, and corporate leaders of local and international organizations.

      Under Mr. Owharo's leadership, the GMG has executed successful projects for various organizations, including the USAID, Ghana Government Health Service, Ministry of Food and Agriculture, and the UN-World Food Program. As the founder of the International Community of Africans in Diaspora (ICAD), Mr. Owharo has continued to promote the welfare and interests of Africans in the Diaspora.

      Mr. Owharo is a consultant representing West Africa on steel factory establishment in Africa for Freshvale Limited, Russia. He serves as a Board Member for both the Ghana-Nigeria Economic Group and the Nigerians in Diaspora Organization (NIDO), representing various financial investment groups globally. He has also held various leadership positions, including Coordinator-Africa, Diaspora Presidential Support Committee (PSC) 2019, Presidential Liaison Officer for Africa-Diaspora, Aso Rock, Abuja-Nigeria, and member of the AU-ECOSOCC COVID-19 Response Team.`
    },
    {
      id: 'aliyu',
      name: 'Aliyu Ibrahim Yahaya',
      position: 'Executive Director',
      image: '/images/ALIYU-IBRAHIM.jpeg',
      bio: `Aliyu Ibrahim Yahaya serves as the Executive Director at ABVIG, bringing extensive leadership experience and strategic vision to the organization.

      With a strong background in business development and organizational management, Aliyu has been instrumental in driving ABVIG's growth and expanding its reach across key sectors. His expertise spans strategic planning, investment facilitation, and stakeholder engagement.

      As Executive Director, he plays a pivotal role in shaping the organization's direction, overseeing key initiatives, and ensuring the successful execution of ABVIG's mission to connect Africa with global business opportunities. His commitment to excellence and results-driven approach continues to strengthen ABVIG's position as a leading business organization.`
    },
    {
      id: 'valentine',
      name: 'Mr. Valentine Ogege',
      position: 'Executive Secretary: Logistics',
      image: '/images/Valentine-Ogege.png',
      bio: `Mr. Valentine Ogege serves as the Executive Secretary for Logistics at ABVIG, bringing extensive experience in logistics management and operational coordination.

      With a strong background in supply chain management and organizational logistics, Mr. Ogege ensures the smooth execution of ABVIG's events, trade missions, and operational activities. His expertise in coordinating complex logistical operations has been instrumental in the successful delivery of AICIS summits, business forums, and trade missions across Africa and internationally.

      Mr. Ogege's commitment to operational excellence, attention to detail, and ability to manage large-scale events make him an invaluable asset to ABVIG. He continues to play a crucial role in positioning ABVIG as a premier organization for global business facilitation.`
    }
  ];

  return (
    <div>
      <section className="page-hero">
        <h1>Board of Directors</h1>
        <p>Our leadership team</p>
      </section>

      <section className="directors-page-section">
        <div className="container">
          <div className="directors-list">
            {directors.map((director) => (
              <div className="director-card" key={director.id}>
                <div className="director-image" style={{backgroundImage: `url(${director.image})`}}></div>
                <div className="director-info">
                  <h3>{director.name}</h3>
                  <p className="director-title">{director.position}</p>
                  <div className="director-bio">
                    <p className="director-summary">
                      {expanded[director.id] 
                        ? director.bio 
                        : director.bio.split('\n\n')[0] + (director.bio.split('\n\n').length > 1 ? '...' : '')}
                    </p>
                    {director.bio.split('\n\n').length > 1 && (
                      <button 
                        className="read-more-btn" 
                        onClick={() => toggleReadMore(director.id)}
                      >
                        {expanded[director.id] ? 'Read Less' : 'Read More'}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BoardDirectors;